import { createSlice } from '@reduxjs/toolkit';

import { ISalesState } from './interfaces';
import { loadSalesItem, loadSalesList } from './actions';

export const salesSlice = createSlice({
  name: 'sales',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as ISalesState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadSalesList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadSalesItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
